import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Workspace header injection — anything stored under `probe_workspace_id` in
// localStorage will be sent as X-Workspace-Id on every request, so the backend
// can scope responses to the active workspace.
api.interceptors.request.use((config) => {
  const wid = typeof window !== "undefined" ? localStorage.getItem("probe_workspace_id") : null;
  if (wid) {
    config.headers = config.headers || {};
    config.headers["X-Workspace-Id"] = wid;
  }
  return config;
});

// Global 401 handling — when the session cookie expires, any authenticated
// API call returns 401. Redirect to /login once (hard navigation kills all
// in-flight polling timers). Auth endpoints are exempt so login failures and
// the initial /auth/me probe don't trigger redirects, and public pages are
// left alone.
const PUBLIC_PATHS = [/^\/$/, /^\/login$/, /^\/signup$/, /^\/legal\//, /^\/contact$/, /^\/accept-invite$/, /^\/join\//];
let redirectingToLogin = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/") && typeof window !== "undefined" && !redirectingToLogin) {
      const path = window.location.pathname;
      const isPublic = PUBLIC_PATHS.some((re) => re.test(path));
      if (!isPublic) {
        redirectingToLogin = true;
        localStorage.removeItem("probe_workspace_id");
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export const wsUrl = (path) => BACKEND_URL.replace(/^http/, "ws") + path;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
